<div class="tag-list-container">
    <ng-container *ngIf="showTitle">
        <div class="tag-list-container--title">{{ title }}</div>
    </ng-container>
    <ng-template ngFor let-item [ngForOf]="tags">
        <div class="tag-list-container--tag" *ngIf="!closeTagOnLeft">
          {{item}}
          <sc-icon *ngIf="canCloseTag"
            id="close-tag"
            class="tag-list-container__close"
            [icon]="'close'"
            [size]="'0_5'"
            (click)="close(item)"></sc-icon>
        </div>
        <div class="d-inline-flex" *ngIf="closeTagOnLeft">
            <div class="tag-list-container__left-close" *ngIf="canCloseTag" 
            (click)="close(item)">
                <sc-icon 
                id="close-tag"
                [icon]="'close'"
                [size]="'0_5'"></sc-icon>
            </div>
            <div [ngClass]="{'tag-list-container--tag-with-close': canCloseTag, 'tag-list-container--tag': !canCloseTag}">
            {{item}}
            </div>
        </div>
    </ng-template>
</div>
